"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AssistantSidebar;
var _react = _interopRequireWildcard(require("react"));
var _AssistantProvider = require("./AssistantProvider");
var _ThreadHeader = _interopRequireDefault(require("./ThreadHeader"));
var _ThreadView = _interopRequireDefault(require("./ThreadView"));
var _FeedbackModal = _interopRequireDefault(require("./FeedbackModal"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const APP_CHROME_HEIGHT = 64;
function AssistantSidebar() {
  const {
    sidebarOpen,
    setSidebarOpen,
    sidebarWidth,
    setSidebarWidth
  } = (0, _AssistantProvider.useAssistant)();
  const [dragging, setDragging] = (0, _react.useState)(false);
  const [sidebarTop, setSidebarTop] = (0, _react.useState)(APP_CHROME_HEIGHT);
  const startXRef = (0, _react.useRef)(0);
  const startWRef = (0, _react.useRef)(0);
  const handleRef = (0, _react.useRef)(null);
  const isFullScreen = typeof window !== 'undefined' && sidebarWidth >= window.innerWidth * 0.95;
  const onPointerDown = e => {
    var _handleRef$current;
    e.preventDefault();
    e.stopPropagation();
    startXRef.current = e.clientX;
    startWRef.current = sidebarWidth;
    setDragging(true);
    (_handleRef$current = handleRef.current) === null || _handleRef$current === void 0 || _handleRef$current.setPointerCapture(e.pointerId);
  };
  const onPointerMove = e => {
    if (!dragging) return;
    const delta = startXRef.current - e.clientX;
    const next = Math.min(_constants.SIDEBAR.MAX_WIDTH, Math.max(_constants.SIDEBAR.MIN_WIDTH, startWRef.current + delta));
    setSidebarWidth(next);
  };
  const onPointerUp = e => {
    var _handleRef$current2;
    setDragging(false);
    (_handleRef$current2 = handleRef.current) === null || _handleRef$current2 === void 0 || _handleRef$current2.releasePointerCapture(e.pointerId);
  };
  (0, _react.useEffect)(() => {
    try {
      localStorage.setItem('sa_sidebar_width', String(sidebarWidth));
    } catch (_unused) {}
  }, [sidebarWidth]);
  const updateTop = (0, _react.useCallback)(() => {
    const remaining = Math.max(0, APP_CHROME_HEIGHT - window.scrollY);
    setSidebarTop(remaining);
  }, []);
  (0, _react.useEffect)(() => {
    if (!sidebarOpen) return;
    updateTop();
    window.addEventListener('scroll', updateTop, {
      passive: true
    });
    return () => window.removeEventListener('scroll', updateTop);
  }, [sidebarOpen, updateTop]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!sidebarOpen && (0, _jsxRuntime.jsx)("button", {
      className: "tw-fixed tw-bottom-6 tw-right-6 tw-z-[9999] tw-w-14 tw-h-14 tw-rounded-full tw-border-none tw-bg-sa-primary tw-text-white tw-cursor-pointer tw-shadow-[0_4px_20px_rgba(0,38,119,0.4)] tw-flex tw-items-center tw-justify-center tw-transition-all hover:tw-scale-110 hover:tw-shadow-[0_6px_28px_rgba(0,38,119,0.5)] tw-font-sa tw-animate-bounce",
      onClick: () => setSidebarOpen(true),
      "aria-label": "Open SmartAssist",
      title: "Open SmartAssist",
      style: {
        animationIterationCount: 3,
        animationDuration: '1.5s'
      },
      children: (0, _jsxRuntime.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [(0, _jsxRuntime.jsx)("path", {
          d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z",
          fill: "white",
          opacity: "0.95"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: "8",
          cy: "10",
          r: "1.2",
          fill: "currentColor"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: "12",
          cy: "10",
          r: "1.2",
          fill: "currentColor"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: "16",
          cy: "10",
          r: "1.2",
          fill: "currentColor"
        })]
      })
    }), sidebarOpen && (0, _jsxRuntime.jsxs)("aside", {
      className: isFullScreen ? 'tw-fixed tw-right-0 tw-flex tw-flex-col tw-z-[9999] tw-animate-sa-slide-in' : 'tw-fixed tw-right-0 tw-flex tw-flex-col tw-bg-sa-surface tw-border-l tw-border-sa-border tw-shadow-sa-lg tw-z-[9999] tw-animate-sa-slide-in tw-font-sa tw-text-sm tw-text-sa-text tw-leading-normal',
      style: isFullScreen ? {
        width: sidebarWidth,
        top: 0,
        height: '100vh',
        fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
        fontSize: '15px',
        color: '#1a1a2e',
        lineHeight: 1.6,
        letterSpacing: '-0.01em',
        background: 'linear-gradient(145deg, #f8f9fc 0%, #eef1f8 50%, #f0f4ff 100%)'
      } : {
        width: sidebarWidth,
        top: sidebarTop,
        height: "calc(100vh - ".concat(sidebarTop, "px)")
      },
      role: "complementary",
      "aria-label": "SmartAssist sidebar",
      children: [(0, _jsxRuntime.jsx)("div", {
        ref: handleRef,
        className: "tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1.5 tw-cursor-col-resize tw-z-[2] tw-transition-colors tw-touch-none ".concat(dragging ? 'tw-bg-sa-primary/40' : 'tw-bg-transparent hover:tw-bg-sa-primary/25'),
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onPointerUp: onPointerUp,
        onPointerCancel: onPointerUp,
        role: "separator",
        "aria-orientation": "vertical",
        tabIndex: 0,
        "aria-label": "Resize sidebar"
      }), (0, _jsxRuntime.jsx)(_ThreadHeader.default, {
        mode: "sidebar",
        onClose: () => setSidebarOpen(false)
      }), (0, _jsxRuntime.jsx)(_ThreadView.default, {
        mode: isFullScreen ? 'standalone' : 'sidebar'
      }), (0, _jsxRuntime.jsx)(_FeedbackModal.default, {})]
    })]
  });
}